export default {
  users: [],
  user: {},
};
